<template>
<div class="chapter">
<div class="inner_page">
<div class="reviewPage" id="rev01">
<a id="pageii">
<h2 class="reviewPageHead"><span class="bold">Praise for<br/> <em class="italic">TO CATCH A HIGHLANDER</em></span></h2>
<p class="reviewPageText">“Love and laughter, poignancy and emotional intensity, endearing characters, and a charming plot, are the ingredients in Hawkins’s utterly delightful tale.”</p>
<p class="reviewPageSource">—<em class="italic">Romantic Times</em></p>
<p class="reviewPageText">“Karen Hawkins’s best book to date! Fast, sensual, and brilliant, it tantalizes and pleases all in the same breath…. This is romance at its best!”</p>
<p class="reviewPageSource">—Romance and More!</p>
<p class="reviewPageSubhead"><span class="bold"><em class="italic">TO SCOTLAND, WITH LOVE</em></span></p>
<p class="reviewPageText">“Hawkins brings another hardheaded MacLean brother and a sassy miss together in a sensual battle of the sexes. Her humor, intelligent characters, and story are simply delightful.”</p>
<p class="reviewPageSource">—<em class="italic">Romantic Times</em></p>
<p class="reviewPageSubhead"><span class="bold"><em class="italic">HOW TO ABDUCT A HIGHLAND LORD</em></span></p>
<p class="reviewPageText">“Hawkins takes a fiery Scot lass and a wastrel lord and puts them together in a match made in, well, not heaven, but one that’s heated, exciting, and touching. Hawkins excels at taking tried-and-true plotlines and turning them into fresh, vibrant books.”</p>
<p class="reviewPageSource">—<em class="italic">Romantic Times</em></p>
<p class="reviewPageText">“In <em class="italic">How to Abduct a Highland Lord,</em> the characters are as wonderful as the story…. [It] is laced with passion and drama, and with its wonderfully romantic and thrilling ending, it’s a story you don’t want to miss!”</p>
<p class="reviewPageSource">—JoyfullyReviewed.com</p>
</a><a id="pageiii">
<p class="reviewPageSubhead"><span class="bold">…and for all the delightfully sexy romances of Karen Hawkins</span></p>
<p class="reviewPageText">“Karen Hawkins knows how to keep a reader entranced from first page to last.”</p>
<p class="reviewPageSource">—Joan Johnston</p>
<p class="reviewPageText">“Karen Hawkins never fails to please!”</p>
<p class="reviewPageSource">—Victoria Alexander</p>
<p class="reviewPageText">“Karen Hawkins writes fast, fun, and sexy stories!”</p>
<p class="reviewPageSource">—Christina Dodd</p>
<p class="reviewPageText">“A lively, sexy escapade…”</p>
<p class="reviewPageSource">—Linda Howard</p>
<p class="reviewPageText">“Saucy, witty flirtation…excitement and passion.”</p>
<p class="reviewPageSource">—<em class="italic">Publishers Weekly</em></p>
<p class="reviewPageText">“Luscious, romantic, witty, sexy, and emotional.”</p>
<p class="reviewPageSource">—<em class="italic">Romantic Times</em></p>
<p class="reviewPageText">“Fast paced, lively, sexy, and laugh-out-loud funny.”</p>
<p class="reviewPageSource">—Romance and More!</p>
<p class="reviewPageText">“An enjoyable fast-paced read. The sensuality is steamy….”</p>
<p class="reviewPageSource">—The Best Reviews</p>
<p class="reviewPageText">“If you like your novels fast paced and full of laugh-out-loud fun, this is the one for you!”</p>
<p class="reviewPageSource">—Romance Reviews Today</p>
<p class="reviewPageText">“I laughed, cried, and fell in love…. Every character was so well written that they seemed as though they could jump right off the page….”</p>
<p class="reviewPageSource"><span class="bold">—Fresh Fiction</span></p>
</a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781439164341_rev01.vue?764c0cae